export default (theme) => ({
	root: {
		width: "100%",
		height: "100%",
		alignContent: "center",
		alignItems: "center",
		textAlign: "center",
		display: "flex",
		justifyContent: "center"
	},
	rootPOI: {
		width: "100%",
		height: "100%",
		alignContent: "center",
		alignItems: "center",
		display: "flex",
		justifyContent: "center",
		overflow: "hidden"
	},
	canvas: {
		height: "100%",
		width: "auto"
	},
	canvasPOI: {
		height: "calc(100vh - 50px - 4rem)",
		width: "auto"
	},
	arrowsContainer: {
		position: "absolute",
		bottom: theme.spacing.unit * 2,
		left: "36vw"
	},
	arrows: {
		minWidth: "auto",
		padding: 0
	},
	arrowLeft: {
		marginRight: theme.spacing.unit
	},
	arrowRight: {},
	arrowIcon: {
		width: "2.5rem",
		height: "2.5rem",
		fill: theme.palette.primary.contrastText
	},
	[theme.breakpoints.down("sm")]: {
		arrowsContainer: {
			left: "50vw"
		},
		arrowLeft: {
		},
		arrowRight: {
		}
	}
});
